<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 row">
      <div class="col-lg-6 col-sm-12">
        <div class="font20">
          <i class="fa fa-arrow-left click" routerLink="../../"></i>
          {{ learningPath?.name }} - L({{ learningPath?.id }})
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 text-right sm-mt sm-text-left">
        <div>
          <button
            class="btn btn-outline-danger btn-sm mr-2"
            data-toggle="modal"
            data-target="#deleteModalCenter"
          >
            Delete
          </button>
          <button
            class="btn btn-outline-secondary btn-sm mr-2"
            [routerLink]="['/learningPath/edit', learningPath?.id]"
          >
            Edit
          </button>
          <button
            class="btn btn-secondary btn-sm"
            data-toggle="modal"
            data-target="#assignModal"
          >
            Assign to...
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-12">
        <div class="bg-white px-4 py-1 bg-box-shadow">
          <div class="my-4">
            <p class="text-grey font12 mb-1">DESCRIPTION</p>
            <p class="font14">
              {{ learningPath?.description }}
            </p>
          </div>
          <div class="my-4">
            <p class="text-grey font12 mb-1">DATE CREATED</p>
            <p class="font14">{{ learningPath?.createdAt | date }}</p>
          </div>
          <div class="my-4">
            <p class="text-grey font12 mb-1">RESTRICTED TO</p>
            <p
              *ngIf="
                learningPath?.department &&
                learningPath?.restriction === 'DEPARTMENT'
              "
              class="font14"
            >
              {{ learningPath?.department?.name }}
            </p>
            <p
              *ngIf="
                learningPath?.division &&
                learningPath?.restriction === 'DIVISION'
              "
              class="font14"
            >
              {{ learningPath?.division?.name }}
            </p>
            <p
              *ngIf="learningPath?.unit && learningPath?.restriction === 'UNIT'"
              class="font14"
            >
              {{ learningPath?.unit?.name }}
            </p>
            <p *ngIf="!learningPath?.restricted" class="font14">
              Not Restricted
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12">
        <div class="bg-box-shadow">
          <div class="bg-white px-4 py-3">
            <div class="font18 font-bold">
              Courses
              <span class="badge-count badge-green">{{ courses?.length }}</span>
            </div>
          </div>
          <hr class="my-0" />
          <div class="bg-white pb-5 pt-1 px-4 course-container">
            <div
              class="row my-4 click"
              id="courses"
              *ngFor="let course of courses"
              [routerLink]="['/courses/course-details', course?.code]"
            >
              <div class="col-lg-4 col-sm-12">
                <div class="p-r">
                  <img
                    src="{{ course?.imageUrl }}"
                    alt=""
                    class="border-radius w-100 courseImg"
                  />
                  <div>
                    <span
                      class="badge "
                      [ngClass]="
                        course.progress == 100 ? 'green-badge' : 'yellow-badge'
                      "
                      >{{
                        course?.progress == 100 ? 'Completed' : 'Ongoing'
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-sm-12 my-auto">
                <p class="font-bold mt-2">
                  {{ course?.title }}
                </p>
                <p class="text-grey font12">
                  {{ course?.category?.name }} | {{ course?.subCategory?.name }}
                </p>
                <div
                  class="mt-4 d-flex justify-content-between record py-2 px-3 col-lg-9 col-sm-12"
                >
                  <div class="rating rating{{ rating(course) }}">
                    <span>☆</span><span>☆</span><span>☆</span><span>☆</span
                    ><span>☆</span>
                  </div>
                  <div class="font14">Level: {{ course?.level }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-wrapper mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
<!-- Modal -->
<div
  class="modal fade"
  id="assignModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="assignModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" [@carouselAnimation]="currentPage">
      <div class="modal-body" *ngIf="currentPage == 'select-participants'">
        <div class="nav-card bg-white px-4 py-3">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Individuals-tab"
                data-toggle="pill"
                href="#Individuals"
                role="tab"
                aria-controls="Individuals"
                aria-selected="true"
                >Staffs</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="Departments-tab"
                data-toggle="pill"
                href="#Departments"
                role="tab"
                aria-controls="Departments"
                aria-selected="false"
                >Departments</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="Divisions-tab"
                data-toggle="pill"
                href="#Divisions"
                role="tab"
                aria-controls="Divisions"
                aria-selected="false"
                >Divisions</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="Units-tab"
                data-toggle="pill"
                href="#Units"
                role="tab"
                aria-controls="Units"
                aria-selected="false"
                >Units</a
              >
            </li>
          </ul>
        </div>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="Individuals"
            role="tabpanel"
            aria-labelledby="Individuals-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input 
                    type="text" 
                    placeholder="Search"
                    #query
                    (keyup)="filterStaff(query.value)" 
                 />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under" (click)="sortByName()">Name</a>
                      <a class="dropdown-item click" (click)="sortByDate()">Date</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-2"
                    *ngFor="
                      let staff of staffs
                        | paginate
                          : {
                              itemsPerPage: staffPaginationInfo.size,
                              totalItems: staffPaginationInfo.totalElements,
                              currentPage: staffPaginationInfo.number
                            };
                      index as i
                    "
                  >
                    <input
                      type="checkbox"
                      (change)="selectDeselctStaff(staff?.id)"
                      id="checkbox{{ i }}"
                      class="checkbox"
                    />
                    <label for="checkbox{{ i }}">
                      <div
                        class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                      >
                        <div class="d-flex align-items-center">
                          <div class=" mr-3">
                            <img src="{{ 
                              staff?.user?.avatarUrl
                              ? staff?.user?.avatarUrl
                              : 'assets/images/profile.png' }}" alt="" 
                              class="rounded-circle" width="50" height="50"
                            />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">
                              {{ staff?.user?.fullName }}
                            </p>
                            <p class="mb-0 text-grey font14">
                              {{ staff?.user?.username }}
                            </p>
                          </div>
                        </div>
                        <div class="check  d-none">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <pagination-controls
                    (pageChange)="navigateStaffNextPage($event)"
                  ></pagination-controls>
                </div>
              </div>
            </div>
            <div class="my-2 d-flex justify-content-end">
              <button
                class="btn btn-secondary btn-sm"
                (click)="chooseDate('choose-dueDate', 'staff')"
              >
                Continue
              </button>
            </div>
          </div>
          <div
            class="tab-pane fade "
            id="Departments"
            role="tabpanel"
            aria-labelledby="Departments-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input 
                    type="text" 
                    placeholder="Search"
                    #query
                    (keyup)="filterDepartment(query.value)" />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-2"
                    *ngFor="let department of departments; index as i"
                  >
                    <input
                      type="checkbox"
                      (change)="selectDeselectDepartments(department?.id)"
                      id="department{{ i }}"
                      class="checkbox"
                    />
                    <label for="department{{ i }}">
                      <div
                        class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                      >
                        <div class="d-flex align-items-center">
                          <div class=" mr-3">
                            <img src="assets/icons/people.png" alt="" />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">
                              {{ department?.name }}
                            </p>
                            <p class="mb-0 text-grey font14">
                              {{ department?.numberOfUsers }} Staff(s)
                            </p>
                          </div>
                        </div>
                        <div class="check  d-none">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-2 d-flex justify-content-end">
              <button
                class="btn btn-secondary btn-sm"
                (click)="chooseDate('choose-dueDate', 'department')"
              >
                Continue
              </button>
            </div>
          </div>
          <div
            class="tab-pane fade "
            id="Divisions"
            role="tabpanel"
            aria-labelledby="Divisions-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input 
                    type="text" 
                    placeholder="Search"
                    #query
                    (keyup)="filterDivision(query.value)" />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-2"
                    *ngFor="let divsion of divisions; index as i"
                  >
                    <input
                      type="checkbox"
                      (change)="selectDeselectDivisions(divsion?.id)"
                      id="divsion{{ i }}"
                      class="checkbox"
                    />
                    <label for="divsion{{ i }}">
                      <div
                        class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                      >
                        <div class="d-flex align-items-center">
                          <div class=" mr-3">
                            <img src="assets/icons/people.png" alt="" />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">
                              {{ divsion?.name }}
                            </p>
                            <p class="mb-0 text-grey font14">
                              {{ divsion?.numberOfUsers }} Staff(s)
                            </p>
                          </div>
                        </div>
                        <div class="check  d-none">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-2 d-flex justify-content-end">
              <button
                class="btn btn-secondary btn-sm"
                (click)="chooseDate('choose-dueDate', 'division')"
              >
                Continue
              </button>
            </div>
          </div>
          <div
            class="tab-pane fade "
            id="Units"
            role="tabpanel"
            aria-labelledby="Units-tab"
          >
            <div class="bg-white px-4 pt-1">
              <div
                class="row align-items-center sm-reverse table-search-container"
              >
                <div
                  class="text-green font12 font-bold col-lg-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
                >
                  ADD FILTER
                </div>
                <div class="table-search col-lg-7 col-sm-12">
                  <input 
                    type="text" 
                    placeholder="Search"
                    #query
                    (keyup)="filterUnit(query.value)" />
                </div>
                <div
                  class="sort col-lg-3 col-sm-12 sm-mt sm-mb-2 sm-text-center"
                >
                  <span class="font-bold font14 text-grey mr-3">SORT BY</span>
                  <span class="dropdown click">
                    <span
                      class="font-bold text-green font12 dropdown-toggle"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      >Name <i class="fa fa-chevron-down"></i
                    ></span>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a class="dropdown-item click line-under">Name</a>
                      <a class="dropdown-item click">Class</a>
                      <a class="dropdown-item click">State</a>
                    </div>
                  </span>
                </div>
              </div>
              <div class="py-4">
                <div class="row">
                  <div
                    class="col-lg-6 col-sm-12 my-2"
                    *ngFor="let unit of units; index as i"
                  >
                    <input
                      type="checkbox"
                      (change)="selectDeselectUnits(unit?.id)"
                      id="unit{{ i }}"
                      class="checkbox"
                    />
                    <label for="unit{{ i }}">
                      <div
                        class="bg-grey px-4 py-3 d-flex justify-content-between align-items-center border-radius click"
                      >
                        <div class="d-flex align-items-center">
                          <div class=" mr-3">
                            <img src="assets/icons/people.png" alt="" />
                          </div>
                          <div>
                            <p class="mb-1 font-bold">
                              {{ unit?.name }}
                            </p>
                            <p class="mb-0 text-grey font14">
                              {{ unit?.numberOfUsers }} Staff(s)
                            </p>
                          </div>
                        </div>
                        <div class="check  d-none">
                          <img src="assets/icons/check.png" alt="" />
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-2 d-flex justify-content-end">
              <button
                class="btn btn-secondary btn-sm"
                (click)="chooseDate('choose-dueDate', 'unit')"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-body" *ngIf="currentPage == 'choose-dueDate'">
        <i
          class="fa fa-arrow-left click"
          (click)="chooseDate('select-participants')"
        ></i>
        Back
        <div class="row">
          <div class="col-lg-3 col-sm-12">
            <p class="font-light font18 mt-4 p">
              Please select the due date for this learning path
            </p>
          </div>
          <div class="col-lg-9 col-sm-12 sm-mt">
            <div class="bg-white px-5 py-3">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <p class="font16 mt-2">Choose Due Date</p>
                  <div class="my-4 d-flex justify-content-center">
                    <div class="">
                      <bs-datepicker-inline
                        [minDate]="minDate"
                        (bsValueChange)="onDueDateChange($event)"
                      ></bs-datepicker-inline>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-between p-4">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            (click)="assign()"
            data-dismiss="modal"
            type="button"
            class="btn btn-secondary btn-sm"
            [disabled]="!dueDate"
          >
            AssignPlan
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteModalCenter"
  tabindex="-1"
  role="dialog"
  aria-labelledby="deleteModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLongTitle">Confirm Delete</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center font-light mt-4 mx-5">
        Are you sure you want to delete this learning path? Click the ‘No’
        button to cancel this action
        <div class="d-flex align-items-center justify-content-between m-5">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-dismiss="modal"
          >
            No
          </button>
          <button
            type="button "
            data-dismiss="modal"
            (click)="deleteLearningPath(learningPath?.id)"
            class="btn btn-secondary"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
